import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AuditLogPanelEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

// The audit log currently reads a client schema extension (`psm_auditLog_extension`) that is seeded
// into the Relay store from mock data inside the panel — there is no network round-trip to preload,
// so `getPreloadProps` stays empty. When psm-service ships the real `psm_auditLog` connection,
// preload it here (`getPreloadProps: ({ context }) => ({ queries: { auditLog: { parameters, variables } } })`)
// and switch `usePsmAuditLogEvents` from `useLazyLoadQuery` + seeding to `usePreloadedQuery`.
export const auditLogPanelEntryPoint: EntryPoint<AuditLogPanelEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<AuditLogPanelEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-proactive-support-audit-log-panel" */ './AuditLogPanel.tsx',
		),
		getPreloadProps: () => ({}),
	});
